import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-vimeo",
  "use": "icon-vimeo-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-vimeo\"><title>icon-vimeo</title><path d=\"M431.215 220.817C390.515 307.711 292.265 426 230.166 426c-61.2 0-70.05-130.432-103.466-217.241-16.45-42.723-27.067-32.912-57.9-11.343L50 173.182c44.967-39.508 89.966-85.395 117.616-87.943 31.134-2.981 50.3 18.288 57.467 63.825 9.466 59.844 22.7 152.734 45.8 152.734 18 0 62.35-73.685 64.633-100.035 4.05-38.575-28.383-39.74-56.533-27.699C323.533 28.26 508.865 55.11 431.215 220.817z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol